import { Task as ChecklistTask } from './task.interface';

export interface GetDefaultChecklistDto {
    id: string;
    name: Record<string, string>;
    tasks: ChecklistTask[];
    flis: string[];
    createdAt: Date;
    updatedAt: Date;
    updatedBy: string;
}
